import axios from "../api";
export const getTrendingPlayers = async (limit) => {
    const res = await axios.get(`/discover/trending/players${limit ? `?limit=${limit}` : ""}`);
    return res.data;
};
export const getTrendingEvoPlayers = async () => {
    const res = await axios.get(`/discover/trending/players/evolutions`);
    return res.data;
};
//# sourceMappingURL=getTrending.js.map